import { useQuery } from "@tanstack/react-query";
import { getUsersAdminDetailUserID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ADMIN_USER_QUERY_KEY = "ADMIN_USER_DETAIL";

export const adminUserDetailKeys = {
  detail: [ADMIN_USER_QUERY_KEY],
  detailByUserID: (userID: number) => [...adminUserDetailKeys.detail, userID],
};

export const useAdminUserDataQuery = (userID: number) =>
  useQuery({
    queryKey: adminUserDetailKeys.detailByUserID(userID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getUsersAdminDetailUserID(userID),
    ),
    refetchOnWindowFocus: false,
  });
